/**
 * Canonical browser origin for auth redirects (invite, password recovery).
 * Prefer VITE_PUBLIC_APP_URL in production so links match the deployed host.
 */
export function getPublicAppOrigin(): string {
  const raw =
    typeof import.meta.env.VITE_PUBLIC_APP_URL === "string" ? import.meta.env.VITE_PUBLIC_APP_URL.trim() : "";
  if (raw) {
    try {
      const u = new URL(raw.includes("://") ? raw : `https://${raw}`);
      if (u.protocol !== "http:" && u.protocol !== "https:") return "";
      if (!u.hostname) return "";
      return `${u.protocol}//${u.hostname}${u.port ? `:${u.port}` : ""}`;
    } catch {
      return "";
    }
  }
  if (typeof window !== "undefined") return window.location.origin;
  return "";
}
